import { Constants } from "./constants";

export class ProductDetails {

	id: string;
	brand: string;
	category: string;
	subcategory: string;
	planName: string;

	originalPrice: number;
	price: number;
	monthlyFee: number;
	upfrontCost: number;
	minTotal: number;
	promoCode: string;

	available: string[];
	unavailable: string[];

	allowance: string;
	bandwidth: string;
	contractLength: number;
	contractLengthName: string;

	childProducts: ProductDetails[] = new Array();

	errorCode: string;
	errorDescription: string;

	public static formatPrice(price: number): string {
		return (Math.round(price * 100) / 100 || 0).toString();
	}

	public static beforeTax(total: number): number {
		return total / (1 + Constants.tax_rate);
	}

public get name() {
switch (this.category) {
	case Constants.category_broadband:
		if (
			this.subcategory &&
			this.allowance &&
			this.contractLengthName
		) {
			return `Internet + ${this.subcategory} + ${this.allowance} + ${this.contractLengthName}`;
		}
		break;
	case Constants.category_mobile:
		if (this.allowance &&
			this.contractLengthName
		) {
			return `Mobile + ${this.allowance} + ${this.contractLengthName}`;
		}
		break;
	case Constants.category_energy:
		if (
			this.subcategory &&
			this.allowance
			) {
				return `Energy + ${this.subcategory} + ${this.allowance}`;
			}
		break;
	default:
			return this.planName;
	}
	return this.planName;
}

public addChildProduct(child: ProductDetails) {
	this.childProducts.push(child);
}

public get discount() {
	return this.originalPrice - this.price;
}

public get total() {
	return +this.upfrontCost + +this.monthlyFee;
}

}
